import "core-js/modules/es6.array.is-array";
export function isValidType(type, allowArray) {
  return typeof type === 'string' || typeof type === 'symbol' || !!allowArray && Array.isArray(type) && type.every(function (t) {
    return isValidType(t, false);
  });
}